import { buildAttachmentAwareRequest } from 'repositories/utils/attachmentRequest'

import { berthApiClient } from '../berthApiClient'

import { updateReceptBookingEndpoint } from './endpoint'
import type { UpdateReceptBookingParams, UpdateReceptBookingResponse } from './type'

export const updateReceptBooking = async (
  params: UpdateReceptBookingParams
): Promise<UpdateReceptBookingResponse> => {
  // 添付資料 (attachments) の lastModified が interceptor の自動 decamelize で last_modified に
  // 変換されると BE が拒否するため、updateUnassignedBooking と揃えて attachmentRequest を経由する。
  const { body, config } = buildAttachmentAwareRequest(params)
  const res = await berthApiClient.put<UpdateReceptBookingResponse>(
    updateReceptBookingEndpoint,
    body,
    config
  )
  return res.data
}
